module.exports = __webpack_public_path__ + "static/media/markdown.d66f22c0.svg";